<div class="d-flex footerLink">
  @for (data of (data$ | async)?.children; track data; let i = $index) {
    <div>
      <div class="mr-3" [ngClass]="i === 0 ? 'pr-3' : 'px-3'">
        @if ((isLoggedIn$ | async) || data.title !== 'Purchase Terms & Conditions') {
          <a href="{{data.url}}"
            target="_blank" rel="noopener" class="cstm-anchor-primary">
            {{data?.title}}
          </a>
        }
      </div>
    </div>
  }
</div>